import { render, staticRenderFns } from "./HelpBanner.vue?vue&type=template&id=33cb7394&scoped=true"
import script from "./HelpBanner.vue?vue&type=script&lang=js"
export * from "./HelpBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cb7394",
  null
  
)

export default component.exports